export interface OverviewTable {
  stat: string,
  home: string,
  away: string
}

export const overviewColumns = [
  {
    header: 'Home',
    accessorKey: 'home'
  }, 
  {
    header: 'Team Stats',
    accessorKey: 'stat'
  },
  {
    header: 'Away',
    accessorKey: 'away'
  }
]

export interface BoxscoreTable {
  personId?: number,
  firstName?: string,
  familyName?: string,
  fullName?: string,
  name: string,
  min: string,
  pts: string | number,
  ast: string | number,
  reb: string | number,
  stl: string | number,
  blk: string | number,
  tov: string | number,
  plusMinus: string | number,
  pf: string | number,
  fg: string,
  fg3: string,
  ft: string,
  tsPct?: string
}

export const boxscoreColumns = [
  {
    header: 'Player',
    accessorKey: 'name'
  },
  {
    header: 'MIN',
    accessorKey: 'min'
  },
  {
    header: 'PTS',
    accessorKey: 'pts'
  },
  {
    header: 'FG',
    accessorKey: 'fg'
  },
  {
    header: '3P',
    accessorKey: 'fg3'
  },
  {
    header: 'AST',
    accessorKey: 'ast'
  },
  {
    header: 'REB',
    accessorKey: 'reb'
  },
  {
    header: 'STL',
    accessorKey: 'stl'
  },
  {
    header: 'BLK',
    accessorKey: 'blk'
  },
  {
    header: 'TOV',
    accessorKey: 'tov'
  },
  {
    header: 'PF',
    accessorKey: 'pf'
  },
  {
    header: 'FT',
    accessorKey: 'ft'
  },
  {
    header: '+/-',
    accessorKey: 'plusMinus'
  },
]